<template>
  <fleet-view />
</template>

<script>
import FleetView from '../../components/FleetView.vue';

export default {
  name: 'show-fleet-view',
  components: { FleetView },
};
</script>
